import { render, staticRenderFns } from "./HorizontalDonutChartWidgetV2.vue?vue&type=template&id=2f285842&scoped=true"
import script from "./HorizontalDonutChartWidgetV2.vue?vue&type=script&lang=js"
export * from "./HorizontalDonutChartWidgetV2.vue?vue&type=script&lang=js"
import style0 from "./HorizontalDonutChartWidgetV2.vue?vue&type=style&index=0&id=2f285842&prod&lang=scss&scoped=true"
import style1 from "./HorizontalDonutChartWidgetV2.vue?vue&type=style&index=1&id=2f285842&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f285842",
  null
  
)

export default component.exports